import React from 'react';

function localizacion(posicion){
    var latitude = posicion.coords.latitude
    var longitude = posicion.coords.longitude
}

function error(){
    console.log("Error de posición")
}

navigator.geolocation.getCurrentPosition(localizacion, error)

const HomeGer2 = props => {
    return (
        <div></div>
    )
}

export default HomeGer2